<template>
  <div class="p-2">
    <audiences-table/>
  </div>
</template>

<script>
  import AudiencesTable from "@/modules/marketing/audience/AudiencesTable";

  export default {
    name: "AudienceList",
    components: {AudiencesTable}
  }
</script>

<style scoped>

</style>
